export default "__VITE_ASSET__z4njeHvk__"